import TagManager from 'react-gtm-module'

/**
 * Type para {@link initialize}
 */
export type InitializeType = {
  /** ID da conta no google GTM */
  gtmId: string
}

/**
 *  Configuração inicial da biblioteca.
 * @param config - objeto de configuração, veja @link InitializeType
 */
export const initialize = ({ gtmId }: InitializeType) =>
  TagManager.initialize({
    gtmId,
  })
